import { Box, Button, styled } from "@mui/material";

export const NavigationButtonIcon = styled(Box)<{ size: "large" | "small"; disabled?: boolean }>(({ theme, size, disabled = false }) => ({
  display: "flex",
  height: size === "small" ? 24 : 32,
  width: size === "small" ? 30 : 40,
  border: `1px solid ${theme.palette.primary.main}`,
  borderRadius: 4,
  color: disabled ? theme.palette.biarri.primary.grey : theme.palette.primary.main,
  borderColor: disabled ? theme.palette.biarri.primary.grey : theme.palette.primary.main,
  alignItems: "center",
  justifyContent: "center",
  marginRight: theme.spacing(1),

  "& svg": {
    height: size === "small" ? 18 : 24,
  },
}));

export const ContainerButton = styled(Button)<{ checked: boolean; disabled: boolean }>(({ theme, checked, disabled, variant }) => ({
  display: "flex",
  padding: theme.spacing(1),
  alignItems: "center",
  justifyContent: "space-between",
  margin: ` ${theme.spacing(2)} 0`,
  borderColor: theme.palette.action.focus,
  textAlign: "left",

  "&.navigation-button--checked": {
    "& .navigation-button-icon": {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.common.white,
    },
  },

  "& .navigation-button-icon": {
    transition: "background-color 0.1s ease-in-out, color 0.1s ease-in-out", // Added transition for background-color
  },

  ...(disabled
    ? {
        backgroundColor: "rgba(156, 156, 157, 0.25)",
        cursor: "not-allowed",
      }
    : {
        backgroundColor: "#F9FAFB",
        cursor: "pointer",
        "&:hover": {
          backgroundColor: "rgba(33, 150, 243, 0.05)",
          borderColor: theme.palette.primary.main,
        },
        "&:hover .navigation-button-icon": {
          backgroundColor: theme.palette.primary.main,
          color: theme.palette.common.white,
        },
      }),
}));
